import React, { FC } from "react";
import { useTranslations } from "next-intl";

import { useTheme } from "@/context/Theme.context";
import SidebarMenuItem from "./item";

import { sidebarMenuList } from "../utils/sidebarMenuItems";
import { Theme } from "@/enums";

const SidebarMenu: FC = () => {
  const theme = useTheme();
  const t = useTranslations();

  if (!theme) return null;

  return (
    <nav className="w-full" id="sidebar-menu">
      <h3 className="px-6 pb-4 text-xs uppercase text-white opacity-30">
        {t("control_panel")}
      </h3>
      <ul>
        {sidebarMenuList
          .filter((item) =>
            theme === Theme.GEORGIA && item.title === "purchase_assistant"
              ? !item
              : item,
          )
          .map((item) => (
            <SidebarMenuItem key={item.title} item={item} />
          ))}
      </ul>
    </nav>
  );
};

export default SidebarMenu;
